import { useEffect, useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { toast } from 'material-react-toastify';
import { getExpiryReport } from '../../api/Report';
import { Waiting } from '../../components/Waiting/Waiting';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { ExpiryReport } from '../../interfaces/Report/ExpiryReport/ExpiryReport';
import { getDefaultExpiryReportFilter } from '../../interfaces/Report/ExpiryReport/ExpiryReportFilter';
import { sharedStyles } from '../../utils/Style';
import { ExpiryReportTable } from './ExpiryReportTable';

export const ExpiryReportPage = () => {
  const [report, setReport] = useState<PaginatedResponse<ExpiryReport>>({
    data: [],
    totalCount: 0,
  });
  const [filter, setFilter] = useState(getDefaultExpiryReportFilter);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(undefined);

    getExpiryReport(filter, controller.signal)
      .then((response) => {
        if (!controller.signal.aborted) setReport(response);
      })
      .catch((err: Error) => {
        if (!controller.signal.aborted) {
          setError(err.message);
          toast.error(err.message);
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, [filter, refreshKey]);

  return (
    <Box sx={sharedStyles.pageBody}>
      <Waiting open={loading} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1.5,
          mb: 1.5,
        }}
      >
        <Typography variant='h5' sx={{ ...sharedStyles.pageTitle, my: 'auto' }}>
          Ürün SKT Raporu
        </Typography>
        <Button
          variant='contained'
          startIcon={<RefreshIcon />}
          disabled={loading}
          onClick={() => setRefreshKey((key) => key + 1)}
          sx={sharedStyles.buttonText}
        >
          Yenile
        </Button>
      </Box>

      <Typography variant='body2' color='text.secondary' sx={{ mb: 1.5 }}>
        Son kullanma tarihleri eskiden yeniye sıralanır. SKT girilmemiş ürün ve
        varyantlar en sonda gösterilir.
      </Typography>

      {error ? (
        <Alert severity='error'>{error}</Alert>
      ) : (
        <>
          {!loading && report.data.length === 0 && (
            <Alert severity='info' sx={{ mb: 1.5 }}>
              Gösterilecek ürün veya varyant bulunamadı.
            </Alert>
          )}
          <ExpiryReportTable
            rows={report.data}
            totalCount={report.totalCount}
            pagination={filter.pagination}
            onPagination={(pagination) => setFilter({ pagination })}
          />
        </>
      )}
    </Box>
  );
};
